import { Table as TableUI } from '@mantine/core';
import { useContext } from 'react';
import { TableContext } from '../../Table.context';
import { Wrapper } from './TableHeader.style';

export type TableHeaderProps = {};

export function TableHeader(props: TableHeaderProps) {
  const { config } = useContext(TableContext);
  const { fields } = config;

  function renderTh(field: ITableField) {
    const { title, width } = field;

    const style: React.CSSProperties = {};

    if (width) {
      style.minWidth = width + 'px';
      style.maxWidth = width + 'px';
    }

    return (
      <TableUI.Th style={style} key={field.id}>
        {title}
      </TableUI.Th>
    );
  }

  function renderThs() {
    return fields.map((field) => renderTh(field));
  }
  const ths = <TableUI.Tr>{renderThs()}</TableUI.Tr>;

  return (
    <Wrapper className='TableHeader-wrapper' data-testid='TableHeader-wrapper'>
      {ths}
    </Wrapper>
  );
}

export default TableHeader;
